import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import RoundIcon from 'components/common/RoundIcon/RoundIcon'
import Mixin from 'components/common/Mixin'
import { DONE_STEP_ASSET } from 'constant'
import { CircularProgressbar } from 'react-circular-progressbar'

const MobileStepperHeader = ({ steps, currentStepIndex }) =>
  <Container>
    {currentStepIndex === steps.length - 1 ?
      <ReviewIcon medium asset={ DONE_STEP_ASSET } /> :
      <React.Fragment>
        <ProgressBar
          maxValue={ steps.length - 1 }
          value={ currentStepIndex + 1 } />
        <StepCounter>{ `${currentStepIndex + 1} of ${steps.length - 1}` }</StepCounter>
      </React.Fragment>}

    <StepInfo>
      <CurrentStepTitle>{ steps[currentStepIndex].title }</CurrentStepTitle>
      {currentStepIndex < (steps.length - 1) &&
        <NextStepTitle>{ steps[currentStepIndex + 1].title }</NextStepTitle>}
    </StepInfo>
  </Container>

export default MobileStepperHeader

MobileStepperHeader.propTypes = {
  currentStepIndex: PropTypes.number,
  steps: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  padding: 5px 15px;
  box-shadow: 0 0 10px rgba(113, 113, 113, 0.349);
`

const ReviewIcon = styled(RoundIcon)`
  width: 43px;
  height: 43px;
`

const ProgressBar = styled(CircularProgressbar).attrs({
  strokeWidth: 11
})`
  width: 43px;
  height: 43px;

  .CircularProgressbar-trail {
    stroke: #333;
    stroke-width: 2px;
  }

  .CircularProgressbar-path {
    stroke: #0f874b;
  }
`

const StepCounter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${Mixin.font.GothamBold(12)}
  letter-spacing: -0.5px;
  margin-left: 15px;
  color: #1e1e1e;
`

const StepInfo = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  justify-content: space-around;
`

const CurrentStepTitle = styled.div`
  ${Mixin.font.GothamBold(15)}
  text-align: right;
`

const NextStepTitle = styled.div`
  ${Mixin.font.GothamBook(12)}
  text-align: right;
`
